import { lazy } from "react";

export const SetNewPasswordAsync = lazy(() => import("./SetNewPassword"));
